import axios from './base'
const url = `/banner`

// ================= 轮播图管理（后端 BannerService，tb_banner，/banner*） =================

// 轮播图列表（分页 + 筛选：keyword 标题模糊 / position 字典 _id 精确 / status 精确）
// 返回 data:{list,total,page,page_size}；列表按 位置→状态→排序值 排列
export function getBannerList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 轮播图详情
export function getBannerDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 新增轮播图（position 存字典 banner_position 的数字 _id；展示时间留空=不限）
export function createBanner(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 编辑轮播图
export function updateBanner(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "put",
    data,
  })
}

// 删除轮播图（软删）
export function deleteBanner(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 上架 / 下架（body: {status: 1|0}）
export function updateBannerStatus(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/status`,
    method: "put",
    data,
  })
}
